import "./SurveyTypePill.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import { SurveyDTO } from "@teams/types/api";
import React, { useMemo } from "react";

import { PollyIcon, PollyIconName } from "../../../../_shared/components/PollyIcon";

type Props = {
  survey: SurveyDTO;
};

export const SurveyTypePill: React.FC<Props> = ({ survey }) => {
  const { className, label, icon } = useMemo((): {
    className: string;
    label: React.ReactNode;
    icon?: PollyIconName;
  } => {
    switch (survey.type) {
      case "poll":
        return { className: "survey-type-pill__poll", label: "Question" };
      case "survey":
        return { className: "survey-type-pill__survey", label: "Questions" };
      case "quiz":
        return { className: "survey-type-pill__quiz", label: "Quiz" };
      case "trivia":
        return { className: "survey-type-pill__trivia", label: "Trivia" };
      case "qna":
        return { className: "survey-type-pill__qna", label: "Q&A" };
      case "icebreaker":
        return {
          className: "survey-type-pill__icebreaker",
          label: "Icebreaker",
          icon: "icebreaker",
        };
      case "hot-take":
        return {
          className: "survey-type-pill__hot-take",
          label: "Hot Take",
          icon: "hot-takes",
        };

      default:
        return { className: "survey-type-pill__poll", label: survey.type };
    }
  }, [survey.type]);

  return (
    <Flex gap="gap.smaller" className={`survey-type-pill ${className}`} vAlign="center">
      {icon && <PollyIcon icon={icon} size="small" inheritColor />}
      <Text align="center" weight="bold" size="small" content={label} />
    </Flex>
  );
};
